import { faker } from '@faker-js/faker';
import { Coordinates, CoordinatesWithTimeZone } from '../types';

const createCoordinates = (): Coordinates => ({
  latitude: Number(faker.address.latitude()),
  longitude: Number(faker.address.longitude()),
});

export const fakeCoordinatesFactory = {
  createCoordinates: createCoordinates,

  createCoordinatesWithTimeZone: (): CoordinatesWithTimeZone => ({
    timeZone: faker.address.timeZone(),
    coordinates: createCoordinates(),
  }),
};
